import {CdkDrag, CdkDropList} from '@angular/cdk/drag-drop';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {RouterLink} from '@angular/router';
import {
  NbAccordionModule,
  NbActionsModule,
  NbBadgeModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbListModule,
  NbRadioModule,
  NbSelectModule,
  NbSpinnerModule,
  NbTabsetModule,
  NbTagModule,
  NbToggleModule,
  NbTooltipModule
} from '@nebular/theme';
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';
import {FormlyModule} from '@ngx-formly/core';
import {TuiItem} from '@taiga-ui/cdk';
import {TuiScrollable, TuiScrollbar} from '@taiga-ui/core';
import {TuiCarouselComponent, TuiPagination} from '@taiga-ui/kit';
import {
  CatalogsLinksComponent,
  FeaturesModule,
  FilterCountComponent,
  FilterPanel,
  FormatSizePipe,
  SharedModule,
  SortPipe,
  UploaderComponent
} from 'compob2b-libs';
import {TableModule} from 'compob2b-table';
import {NgxPaginationModule} from 'ngx-pagination';
import {BaseModule} from '../../../../../../compob2b-table/lib/components/base/base.module';
import {AdminSharedModule} from '../../../admin-shared/admin-shared.module';
import {BreadcrumbsComponent} from '../../../admin-shared/breadcrumbs/breadcrumbs.component';
import {DamRelatedCollectionComponent} from '../dam-related-collection/dam-related-collection.component';
import {DamSearchElasticComponent} from '../dam-search-elastic/dam-search-elastic.component';
import {SecuredImageComponent} from '../secured-image/secured-image.component';
import {ViewChangingTabsComponent} from '../view-changing-tabs/view-changing-tabs.component';
import {AttachedElementsComponent} from './create-update/attached-elements/attached-elements.component';
import {CreateUpdateFilesComponent} from './create-update/create-update-files.component';
import {DamItemInfoViewComponent} from './create-update/dam-item-page-tabs/info-tab/dam-item-info-view/dam-item-info-view.component';
import {DamItemVersionsComponent} from './create-update/dam-item-page-tabs/info-tab/dam-item-versions/dam-item-versions.component';
import {DamItemPersonComponent} from './dam-item-person/dam-item-person.component';
import {DamItemShowPersonComponent} from './dam-item-show-person/dam-item-show-person.component';
import {DamItemVersionsTransformationComponent} from './dam-item-versions-transformation/dam-item-versions-transformation.component';
import {DamPreviewImageComponent} from './dam-preview-image/dam-preview-image.component';
import {DamPreviewTextComponent} from './dam-preview-text/dam-preview-text.component';
import {DamPreviewVideoComponent} from './dam-preview-video/dam-preview-video.component';
import {DamElementPreviewComponent} from './dam-table/dam-element-preview/dam-element-preview.component';
import {PlatesViewComponent} from './dam-table/plates-view/plates-view.component';
import {DamCatalogComponent} from './dam-table/dam-catalog.component';

import {FilesRoutingModule} from './files-routing.module';
import {PermissionsComponent} from './permissions/permissions.component';
import {FileChangeHistoryComponent} from './create-update/dam-item-page-tabs/file-change-history/file-change-history.component';
import {NgSelectModule} from '@ng-select/ng-select'
import {AppTreeToggleComponent} from '../../../admin-shared/app-tree-toggle/app-tree-toggle.component'
import {FileUploadComponent} from '../file-upload/file-upload.component'

@NgModule({
  declarations: [
    CreateUpdateFilesComponent,
    PermissionsComponent,
    DamCatalogComponent,
    DamItemVersionsComponent,
    DamPreviewTextComponent,
    DamPreviewImageComponent,
    DamPreviewVideoComponent,
    PlatesViewComponent,
    DamElementPreviewComponent,
    AttachedElementsComponent,
    AttachedElementsComponent,
    DamItemInfoViewComponent,
    DamItemInfoViewComponent,
    DamItemVersionsTransformationComponent,
    DamItemPersonComponent,
    DamItemShowPersonComponent,
    FileChangeHistoryComponent,
  ],
  exports: [
    DamCatalogComponent,
    DamPreviewTextComponent,
    DamPreviewImageComponent,
    DamPreviewVideoComponent,
    DamItemVersionsComponent,
    PlatesViewComponent,
    FileChangeHistoryComponent,
    DamElementPreviewComponent,
    PermissionsComponent,
  ],
  imports: [
    CommonModule,
    FilesRoutingModule,
    ReactiveFormsModule,
    AdminSharedModule,
    NbCardModule,
    TableModule,
    NbButtonModule,
    NbIconModule,
    NbActionsModule,
    NbToggleModule,
    NbTooltipModule,
    FormlyModule,
    FormlyBootstrapModule,
    NbSelectModule,
    NbBadgeModule,
    NbSpinnerModule,
    NbCheckboxModule,
    NbListModule,
    NbRadioModule,
    NbInputModule,
    FormsModule,
    NgxPaginationModule,
    NbTabsetModule,
    NbTagModule,
    MatMenuModule,
    MatButtonModule,
    NgSelectModule,
    NbAccordionModule,
    NbFormFieldModule,
    CdkDropList,
    CdkDrag,
    FeaturesModule.forDam(),
    TuiScrollbar, TuiScrollable, BreadcrumbsComponent, BaseModule, SharedModule, TuiCarouselComponent, RouterLink, SecuredImageComponent, DamRelatedCollectionComponent, ViewChangingTabsComponent, DamSearchElasticComponent, TuiItem, FilterCountComponent, SortPipe, FilterPanel, FeaturesModule, TuiPagination, CatalogsLinksComponent, UploaderComponent, FormatSizePipe, AppTreeToggleComponent, FileUploadComponent,
  ]
})
export class DamFilesModule {
}
